export default {
  routerList: [
    {
      path: '/liaisonStationNew',
      redirect: '/liaisonStationNewHome'
    },
    {
      path: '/liaisonStationNewHome',
      component: () => import('@/views/liaisonStationNew/liaisonStationNew/homePage.vue'),
      name: '家站首页(新)',
      children: []
    },
   
  ]
}
